export const downloadFile = (file: Blob | File): void => {
  const fileUrl = URL.createObjectURL(file);
  const fileLink = document.createElement('a');
  fileLink.href = fileUrl;
  fileLink.download = (file as File)?.name ?? '';
  fileLink.rel = 'noopener noreferer';
  document.body.appendChild(fileLink);
  fileLink.click();
  document.body.removeChild(fileLink);
};
